import type { ReactNode } from 'react';

import { Separator } from '@/components/ui/separator';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AdminSidebar } from '@/features/admin/components/admin-sidebar';
import { UserMenu } from './components/user-menu';

interface AdminLayoutProps {
  children: ReactNode;
}

/**
 * Shell for the /admin section.
 *
 * Deliberately distinct from AppLayout: the sidebar makes it obvious at a
 * glance that you are acting as an administrator rather than using the product
 * normally. SidebarProvider persists the collapsed state to a cookie.
 */
export function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <SidebarProvider>
      <AdminSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <h1 className="text-sm font-medium">Administration</h1>
          <div className="ml-auto">
            <UserMenu />
          </div>
        </header>
        <main className="flex-1 p-6 bg-muted/30">{children}</main>
      </SidebarInset>
    </SidebarProvider>
  );
}
